// Per spec section 3.8 + 7.12: manual retry bubble after silent retry exhausts.
// Silent retry (Task 14's withSilentRetry) handles network blips invisibly. When
// that has already failed, OR a non-retryable error (HTTP 5xx, Bedrock error
// frame) surfaces, useMiklaChat shows this bubble. Click invokes the consumer's
// onRetry, which calls regenerate() for a fresh message_id.

export interface RetryBubbleProps {
  onRetry: () => void
}

export function RetryBubble({ onRetry }: RetryBubbleProps) {
  return (
    <div
      data-testid="retry-bubble"
      className="self-start bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm flex items-center gap-3"
    >
      <span>Connection issue &mdash; couldn&apos;t get a response.</span>
      <button
        type="button"
        onClick={onRetry}
        className="text-accent font-medium hover:underline"
        aria-label="Retry"
      >
        Retry
      </button>
    </div>
  )
}
